import { EyeOutlined } from "@ant-design/icons";
import { Button } from "@rumbledirect/ui";
import { Space, Tag } from "antd";

export const dashboardTasksColumns = [
  {
    title: "Taak",
    dataIndex: "title",
    key: "title",
    render: (t: string) => <span className="font-medium">{t}</span>,
  },
  {
    title: "Toegewezen aan",
    dataIndex: "assignee",
    key: "assignee",
  },
  {
    title: "Prioriteit",
    dataIndex: "priority",
    key: "priority",
    render: (p: string) => {
      const color: Record<string, string> = { high: "red", medium: "default" };
      const label: Record<string, string> = {
        high: "Spoed",
        medium: "Normaal",
      };
      return <Tag color={color[p] || "default"}>{label[p] || p}</Tag>;
    },
  },
  {
    title: "Acties",
    key: "actions",
    render: () => (
      <Space size="small">
        <Button icon={<EyeOutlined />} variant="light" />
      </Space>
    ),
  },
];
